import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ManageAccessComponent } from './manage-access.component';
import { ShareAccessComponent } from './share-access/share-access.component';
import { ShareAccessDisabledGuard } from '../../../core/auth/guards/share-access-disabled.guard';
import { CustomerLevelAccessGuard } from '../../../core/auth/guards/customer-level-access.guard';
import { NotSsoUserGuard } from '../../../core/auth/guards/not-sso-user.guard';
import { sessionResolver } from '../../../api/session/session.resolver';
import { accountDataResolver } from '../../../api/account-data/account-data.resolver';

const routes: Routes = [
  {
    path: '',
    component: ManageAccessComponent,
    canActivate: [CustomerLevelAccessGuard, NotSsoUserGuard],
    data: {title: 'Manage Access'},
    resolve: {
      userSession: sessionResolver
    }
  },
  {
    path: 'share',
    component: ShareAccessComponent,
    canActivate: [ShareAccessDisabledGuard, CustomerLevelAccessGuard, NotSsoUserGuard],
    data: {title: 'Share Access'},
    resolve: {
      accountsData: accountDataResolver,
      userSession: sessionResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageAccessRoutingModule {
}
